module.exports = __webpack_public_path__ + "static/Aline-161ef616a96602a2ad92c92c2ba8e5d5.jpg";